// SPDX-FileCopyrightText: 2023 - 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2023 - 2025 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

import Tooltip from '@mui/material/Tooltip'
import { HelmholtzIcon } from '~/components/icons/HelmholtzIcon'

export default function HgfBadge() {
  return (

    <Tooltip
      title="Helmholtz Research Centre"
      placement='top'
      sx={{
        cursor:'default'
      }}
    >
      <HelmholtzIcon sx={{ width: '3rem', height: '3rem', margin: '0rem 0.25rem ' }}/>
    </Tooltip>

  )
}
